/* unplugin-vue-components disabled */import script from "./contactForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./contactForm.vue?vue&type=script&setup=true&lang=ts"

import "./contactForm.vue?vue&type=style&index=0&id=34bf7f80&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bf7f80"]])

export default __exports__